<template>
  <div class="table-responsive">
    <table class="table bg-white table-sm table-striped table-middle fs-sm">
      <thead>
        <tr>
          <th v-if="$root.user.isAdmin" class="th-shrink" />
          <th>Súčasný dodávateľ</th>
          <th class="text-right">SOPo (€ bez dph/MWh)</th>
          <th class="text-right">Mesačná platba (€ bez dph)</th>
          <th class="text-right">Ročné množstvo (MWh)</th>
          <th class="text-right">Tolerancia odberu - spodná (%)</th>
          <th class="text-right">Tolerancia odberu - horná (%)</th>
          <th class="text-right">Dátum zmeny</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td v-if="$root.user.isAdmin" class="th-shrink">
            <b-dropdown variant="link" no-caret class="btn-p-0">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click.prevent="edit(item.id)">
                <b-icon icon="pencil-square" class="mr-1" />Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(item.id)"
              >
                <b-icon icon="trash" class="mr-1" />Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </td>
          <td>
            <template v-if="item._provider">
              {{ item._provider.name }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.sopo">
              {{ item.sopo | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.monthlyPayment">
              {{ item.monthlyPayment | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.yearlyConsumption">
              {{ item.yearlyConsumption | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.tolLower">
              {{ item.tolLower | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.tolUpper">
              {{ item.tolUpper | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.changeDate">
              {{ item.changeDate | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    energetic: Object,
  },
  methods: {
    edit(id) {
      this.$parent.$parent.$refs.contractForm.id = id
      this.$parent.$parent.add({ type: 'gas', edit: true })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
  },
}
</script>
